import { FileExcelOutlined, FilePdfOutlined, FileTextOutlined, FileZipOutlined } from "@ant-design/icons";
import React from "react";
export const EXPORT_TYPE_XLS = "xls";
export const EXPORT_TYPE_CSV = "csv";
export const EXPORT_TYPE_PDF = "pdf";
export const EXPORT_TYPE_ZIP = "zip";

const buttonStyle = { background: "none", border: "none", cursor: "pointer", width: "100%" };

const ExportOverlay = ({ onExportClick, allowedExportTypes = [] }) => {
  return (
    <div className="export-overlay">
      {allowedExportTypes.map((exportType) => {
        if (typeof exportType === "object") {
          return (
            <button type="button" key={exportType.type} onClick={onExportClick(exportType)} style={buttonStyle}>
              <FileExcelOutlined />
              {exportType.label}
            </button>
          );
        }
        return (
          <button type="button" key={exportType} onClick={onExportClick(exportType)} style={buttonStyle}>
            {exportType === EXPORT_TYPE_XLS && (
              <>
                <FileExcelOutlined />
                Excel
              </>
            )}
            {exportType === EXPORT_TYPE_CSV && (
              <>
                <FileTextOutlined />
                CSV
              </>
            )}
            {exportType === EXPORT_TYPE_PDF && (
              <>
                <FilePdfOutlined />
                PDF
              </>
            )}
            {exportType === EXPORT_TYPE_ZIP && (
              <>
                <FileZipOutlined />
                ZIP
              </>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default ExportOverlay;
